export enum Environment {
  dev = 'dev',
  prod = 'prod',
}
